export * from './mg-wallet.component';



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/components/mg-wallet/index.ts